<script lang="ts">
    import {authFetch} from "../Auth";
    import {strToLocaleDateTime} from "../Utils";
    import {getRouteById} from "../Nav";
    import {overlay} from "../Store";
    import {round} from "ol/math";
    export const params = {}
    let list: any[] = []
    let count: number = 0
    let listPromise: Promise<any>
    let filter = {
        offset: 0,
        limit: 75,
        order: "DESC",
        orderBy: "id"
    }
    const chunkSize = 1024 * 1024; // 1MB chunks
    let currentByte = 0; // Start at the beginning of the file
    let totalFileSize = 0; // Will store the total file size, to know when to stop
    let progressBarValue = 0;
    let downloadButtonDisabled = false
    let allChunks = [];
    async function loadList() {
        let response = await authFetch('export-user/list', {
            method: 'POST',
            body: JSON.stringify(filter),
        })
        if (response.ok) {
            let data = await response.json()
            list = data.list
            count = data.count
        } else {
            alert(response.statusText)
        }
    }

    async function onExport(exportUserId){
        //overlay.set('Downloading')
        try{
            let endChunk = currentByte + chunkSize -1;
            if (endChunk > totalFileSize && totalFileSize > 0) {
                endChunk = totalFileSize - 1;
            }
            downloadButtonDisabled = true;
            let contentDispositionHeader = null;
            let response = await authFetch(`export-user/zip/${exportUserId}`, {
                method: 'GET',
                headers: {
                    'Range': `bytes=${currentByte}-${endChunk}`
                }
            }).then(response => {
                if (response.status === 206) {  // Partial Content (206 status)
                    // Get total file size from the response headers
                    if (!totalFileSize) {
                        totalFileSize = parseInt(response.headers.get('Content-Range').split('/')[1], 10);
                    }
                    contentDispositionHeader = response.headers.get('Content-Disposition');
                    // Process the chunk (you can save it to a file or store in memory)
                    return response.blob();
                } else {
                    throw new Error('Server did not return partial content');
                }
            }).then(blob => {
                // Get the blob (this represents the chunk of the file)
                console.log('Downloaded chunk size:', blob.size / 1024 / 1024, 'MB');
                allChunks.push(blob);
                // Update progress
                currentByte += blob.size;
                updateProgress(currentByte, totalFileSize);

                console.log(`Downloaded ${currentByte} of ${totalFileSize} bytes`);

                // If there are more chunks to download, request the next chunk
                if (currentByte < totalFileSize) {
                    onExport(exportUserId); // Continue downloading the next chunk
                } else {
                    let filename = 'export.zip';
                    if (contentDispositionHeader) {
                        let parts = contentDispositionHeader.split(';');
                        if (parts.length > 0) {
                            filename = parts[1].split('=')[1].replace(/(^"|"$)/g, '').trim();
                        }
                    }
                    downloadButtonDisabled = false
                    const fullBlob = new Blob(allChunks, { type: 'application/zip' });  // Adjust MIME type if necessary
                    let a = document.createElement('a');
                    document.body.appendChild(a);

                    let url = window.URL.createObjectURL(fullBlob);
                    a.href = url;
                    a.download = filename;
                    a.click();

                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }, 10)
                    console.log('Download complete');
                }
                })
                .catch(error => {
                    console.error('Download failed', error);
                });
        } finally {
            //overlay.set(null)
        }
    }

    function update(){
        listPromise = loadList()
    }
    update();

    const updateProgress = (bytesDownloaded, totalBytes) => {
        progressBarValue = ((bytesDownloaded / totalBytes) * 100).toFixed(2);
    };
</script>
<table class="table table-bordered table-sm mt-3">
    <thead class="position-sticky bg-white shadow" style="z-index: 1030; top: 56px;">
    <tr style="border: 0px;">
        <th colspan="100">
            <div class="input-group justify-content-end">
                <button class="btn btn-info"
                        class:disabled={filter.offset===0}
                        on:click={()=>{filter.offset-=filter.limit;update()}}>
                    <i class="bi bi-chevron-left"></i>
                </button>
                <input class="form-control flex-grow-0" type="number" style="width: 5em;"
                       min="1"
                       max={Math.floor(count / filter.limit)+1}
                       step="1"
                       value={(filter.offset / filter.limit)+1}
                       on:change={(ev)=>{filter.offset=(ev.target.value - 1) * filter.limit; update()}}
                >
                <button class="btn btn-info disabled">
                    / {Math.floor(count / filter.limit)+1}
                </button>
                <button class="btn btn-info"
                        class:disabled={list.length < filter.limit}
                        on:click={()=>{filter.offset+=filter.limit;update()}}>
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
            <div class="progress mt-2">
                <div class="progress-bar progress-bar-striped" role="progressbar" style="width: {progressBarValue}%" aria-valuenow="{progressBarValue}" aria-valuemin="0" aria-valuemax="100">{progressBarValue}%</div>
            </div>
        </th>
        <tr style="font-size: 14px;">
            <th>ID</th>
            <th>Тел</th>
            <th>Завершено</th>
            <th>Параметри</th>
            <th>Назва</th>
            <th>Розмір</th>
            <th>Створений</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
    {#await listPromise}
        <tr>
            <td colspan="1000" class="text-center">
                <div class="spinner-grow"></div>
            </td>
        </tr>
    {:then _}
        {#if list.length > 0}
            {#each list as export_user}
                <tr>
                    <td>{export_user.id}</td>
                    <td>{export_user.user.phone ?? '-'}</td>
                    <td>{export_user.finished_at ?? '-'}</td>
                    <td>{export_user.params ?? '-'}</td>
                    <td>{export_user.file_name ?? '-'}</td>
                    <td>
                        {#if export_user.finished_at != null}
                            <td>{(export_user.file_size /1024/1024).toFixed(2)} Mb</td>
                        {:else}
                            <span>-</span>
                        {/if}
                    </td>

                    <td>{strToLocaleDateTime(export_user.created_at)}</td>
                    <td>
                        {#if export_user.finished_at != null}
                            <button class="btn btn-sm btn-primary" on:click={onExport(export_user.id)}  class:disabled={downloadButtonDisabled} ><i class="bi bi-file-zip"></i></button>
                        {:else}
                            <span>-</span>
                        {/if}
                    </td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td colSpan="1000" class="text-center">
                    <div class="alert alert-secondary">Немає завдань</div>
                </td>
            </tr>
        {/if}
    {/await}
    </tbody>
</table>